import React from 'react';
import { connect } from 'react-redux'

import SelectDropdown from '../../Components/SelectDropdown';
import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper, SelectFieldWrapper, SwitchFieldWrapper } from '../../Components/Fields';
import { doPost } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import DatePickerContainer from '../../Components/DatePickerContainer';

import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");

const ENDPOINT = "mitarbeiter"

export const Fields = ({handleChange, tabChange, aktiv, tab, id, anrede, titel, name, familienname, adresse, land, postleitzahl, ort, mobil, telefon, email, fuehrerscheinkarte, fahrerkarte, code_telefon, code_tankstelle, code_fsd, notiz}) => (
    <Grid container spacing={8}>

            <SelectFieldWrapper n={2} name="Anrede">
                <Select
                    key={anrede+"anrede"}
                    value={anrede}
                    onChange={handleChange('anrede')}
                    inputProps={{
                        id: id,
                    }}
                    autoWidth
                >
                    <MenuItem value={1}>Herr</MenuItem>
                    <MenuItem value={2}>Frau</MenuItem>
                </Select>
            </SelectFieldWrapper>

            <TextFieldHelper n={2} value={titel} onChange={handleChange('titel')} label="Titel" />
            <TextFieldHelper n={2} value={name} onChange={handleChange('name')} label="Vorname" />
            <TextFieldHelper n={6} value={familienname} onChange={handleChange('familienname')} label="Familienname" />

            <TextFieldHelper n={12} value={adresse} onChange={handleChange('adresse')} label="Adresse" type="text" />

            <TextFieldHelper n={2} value={land} onChange={handleChange('land')} label="Land" type="text" />
            <TextFieldHelper n={2} value={postleitzahl} onChange={handleChange('postleitzahl')} label="PLZ" type="text" />
            <TextFieldHelper n={8} value={ort} onChange={handleChange('ort')} label="Ort" type="text" />

            <TextFieldHelper n={6} value={mobil} onChange={handleChange('mobil')} label="Mobil" type="text" />
            <TextFieldHelper n={6} value={telefon} onChange={handleChange('telefon')} label="Telefon" type="text" />

            <TextFieldHelper n={12} value={email} onChange={handleChange('email')} label="E-Mail-Adresse" type="email" />

            <TextFieldHelper n={12} rowsMax={300} rows={5} value={notiz} onChange={handleChange('notiz')} label="Notiz" type="text" multiline />
                
            <TextFieldHelper n={6} value={fuehrerscheinkarte} onChange={handleChange('fuehrerscheinkarte')} label="Führerscheinkarte" type="text" />
            <TextFieldHelper n={6} value={fahrerkarte} onChange={handleChange('fahrerkarte')} label="Fahrerkarte" type="text" />

            <Grid item xs={12}><Divider /></Grid>

            <TextFieldHelper n={4} value={code_telefon} onChange={handleChange('code_telefon')} label="Code Telefon" />
            <TextFieldHelper n={4} value={code_tankstelle} onChange={handleChange('code_tankstelle')} label="Code Tankstelle" />
            <TextFieldHelper n={4} value={code_fsd} onChange={handleChange('code_fsd')} label="Code FSD" />

    </Grid>
)

export const Anstellung = ({handleChange, eintritt, austritt, geburtsdatum, svnummer, familienstand, arbeitszeitmodel, wochenstunden, anstellung, anstellungsgrad, id, betriebsstaette, abteilung, funktion, leitstand_gruppe}) => (
    
    <Grid container spacing={8}>
            <Grid item xs={2}>
                <DatePickerContainer
                    dateInput
                    label="Geburtsdatum"
                    value={geburtsdatum}
                    name="geburtsdatum"
                    onChange={handleChange('geburtsdatum')}
                />
            </Grid>
            <TextFieldHelper n={4} value={svnummer} onChange={handleChange('svnummer')} label="SV Nummer" />
            <TextFieldHelper n={6} value={familienstand} onChange={handleChange('familienstand')} label="Familienstand" />

            <TextFieldHelper n={6} value={arbeitszeitmodel} onChange={handleChange('arbeitszeitmodel')} label="Arbeitszeitmodel" />
            <TextFieldHelper n={6} value={wochenstunden} onChange={handleChange('wochenstunden')} label="Wochenstunden" />

            <SelectFieldWrapper n={6} name="Anstellung">
                <Select
                    key={anstellung+"anstellung"}
                    value={anstellung}
                    onChange={handleChange('anstellung')}
                    autoWidth
                >
                    <MenuItem value={"Angestellter"}>Angestellter</MenuItem>
                    <MenuItem value={"Arbeiter"}>Arbeiter</MenuItem>
                </Select>
            </SelectFieldWrapper>

            <SelectFieldWrapper n={6} name="Anstellungsgrad">
                <Select
                    key={anstellungsgrad+"anstellungsgrad"}
                    value={anstellungsgrad}
                    onChange={handleChange('anstellungsgrad')}
                    autoWidth
                >
                    <MenuItem value={"Vollzeit"}>Vollzeit</MenuItem>
                    <MenuItem value={"Teilzeit"}>Teilzeit</MenuItem>
                    <MenuItem value={"Aushilfe"}>Aushilfe</MenuItem>
                </Select>
            </SelectFieldWrapper>

            <Grid item xs={6}>
                <SelectDropdown
                    isMulti={false}
                    name="Betriebsstätte"
                    value={betriebsstaette && betriebsstaette.name && {label: betriebsstaette.name, ...betriebsstaette}}
                    handleChange={handleChange("betriebsstaette")}
                    placeholder="Betriebsstätte auswählen"
                    redux={"betriebsstaetten"}
                    uri={"betriebsstaetten"}
                />
            </Grid>

            <Grid item xs={6}>
                <SelectDropdown
                    isMulti={false}
                    name="Abteilung"
                    value={abteilung && abteilung.name && {label: abteilung.name, ...abteilung}}
                    handleChange={handleChange("abteilung")}
                    placeholder="Abteilung auswählen"
                    redux={"abteilungen"}
                    uri={"abteilungen"}
                />
            </Grid>

            <Grid item xs={6}>
                <SelectDropdown
                    isMulti={false}
                    name="Funktion"
                    value={funktion && funktion.name && {label: funktion.name, ...funktion}}
                    handleChange={handleChange("funktion")}
                    placeholder="Funktion auswählen"
                    redux={"funktion"}
                    uri={"funktion"}
                />
            </Grid>

            <Grid item xs={6}>
                <SelectDropdown
                    isMulti={true}
                    canCreate={false}
                    name="Leitstand Gruppe"
                    value={leitstand_gruppe && leitstand_gruppe.map((item) => { console.log("item", item); return {label:item.name, value: item.id, ...item} })}
                    handleChange={handleChange("leitstand_gruppe")}
                    placeholder="Funktion auswählen"
                    redux={"abteilungen"}
                    uri={"abteilungen"}
                />
            </Grid>

        </Grid>

)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

		return (
			<Dialog
                title="Neuer Kontakt"
                saveAction={this.postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
             >
				<Fields tabChange={this.tabChange} handleChange={this.handleChange} {...newEntry} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/Mitarbeiter/NewEntry.js